import { Maybe, ObjectType } from '@csp/csp-common-model';
import {
  QUESTIONNAIRE_CRITICALITY_CONFIG_V1,
  QuestionnaireCriticalityConfigV1,
} from '../model/QuestionnaireCriticalityConfigV1';

const getQuestionnaireCriticalityConfigFromMeta = (config: unknown): QuestionnaireCriticalityConfigV1 => {
  const criticalityConfigV1 = config as QuestionnaireCriticalityConfigV1;

  return {
    criticalQuestionCodes: criticalityConfigV1.criticalQuestionCodes,
    isCriticalQuestion: (questionCode: string) => criticalityConfigV1.criticalQuestionCodes.includes(questionCode),
  };
};

const fromQuestionnaireCriticalityConfigMetaV1 = (meta: Maybe<ObjectType>): Maybe<QuestionnaireCriticalityConfigV1> => {
  const criticalityConfigV1 = meta?.[QUESTIONNAIRE_CRITICALITY_CONFIG_V1];
  return criticalityConfigV1 ? getQuestionnaireCriticalityConfigFromMeta(criticalityConfigV1) : undefined;
};

export const QuestionnaireCriticalityConfigMapper = {
  fromQuestionnaireCriticalityConfigMetaV1,
};
